import { useQuery } from '@tanstack/react-query';
import { useAuth } from 'react-oidc-context';

import { getUserMe } from './userMe';

export const USER_ME_KEY = 'UserMe';

export const useGetUserMe = () => {
  const { isAuthenticated, isLoading: isAuthLoading } = useAuth();

  const { data, ...restProps } = useQuery({
    queryKey: [USER_ME_KEY],
    queryFn: getUserMe,
    enabled: isAuthenticated && !isAuthLoading,
  });

  return {
    data,
    hasLegacyBillingPlan: data?.billingPlan?.isLegacy ?? false,
    ...restProps,
  };
};
